import React, { useEffect, useState } from 'react';
import { Card, DatePicker, Button, Space, Typography, message, InputNumber, Row, Col, Empty, Select,Popconfirm } from 'antd';
import { 
    QuestionOutlined,
    CheckOutlined, 
    DeleteOutlined, 
    EditOutlined,
    PlusOutlined,
    MinusOutlined,
    PlusCircleOutlined
} from '@ant-design/icons';
import { CheckCircle, Circle } from 'lucide-react'; // Import Lucide icons

import { openNotificationSuccess, openNotificationError } from '../../../Components/Notification/Notification';

import './ControleVoorstelScreen.css'
import AxiosCaller from '../../../authenticatie/AxiosCaller';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Text, Title } = Typography;
const { Option } = Select;

const ControleVoorstelScreen = () => {
    const { get, post, put, del } = AxiosCaller();
    const [voorstellen, setVoorstellen] = useState([]);
    const [selectedVoorstellen, setSelectedVoorstellen] = useState([]);
    const [dateRange, setDateRange] = useState([
        dayjs(), 
        dayjs().add(7, 'day')
    ]);

    const [maxHeight, setMaxHeight] = useState(0);

    useEffect(() => {
        const updateHeight = () => {
            setMaxHeight(0.7 * document.documentElement.clientHeight);
        };

        updateHeight(); // Initialiseren bij eerste render
        window.addEventListener("resize", updateHeight); // Updaten bij schermresizing

        return () => window.removeEventListener("resize", updateHeight); // Cleanup
    }, []);

    const fetchVoorstellen = async () => {
        try {
        if (!dateRange || !dateRange[0] || !dateRange[1]) {
            const response = await get('/Voorstel/')
            sortVoorstellenByDate(response.data)
            setSelectedVoorstellen([])
        }else{
            const response = await post('/Voorstel/getVoorstellenByDate', {
                startDatum: dayjs(dateRange[0]).utc(true),
                eindDatum: dayjs(dateRange[1]).utc(true),
                gevalideerd: false
            });
            
            sortVoorstellenByDate(response.data)
            setSelectedVoorstellen([]);
        }
        } catch (error) {
            openNotificationError("Fout bij ophalen van de voorstellen", error)
            console.error(error);
        }
    };

    const sortVoorstellenByDate = (data) => {
        setVoorstellen(
            data.sort((a, b) => new Date(a.kookDatum) - new Date(b.kookDatum))
        );
    }
    

    useEffect(() => {
        fetchVoorstellen();
    }, [dateRange]);

    const handleDateRangeChange = (dates) => {

        
        
        setDateRange(dates);
    }
   
    

    const handleValidatie = async () => {
        try {
           
            await post('/bestellijn/array', { voorstellen: selectedVoorstellen });
            openNotificationSuccess("voorstellen succesvol gevalideerd")
            fetchVoorstellen();
        } catch (error) {
            openNotificationError("Fout bij valideren van voorstellen", error)
            console.error(error);
        }
    };

    const toggleVoorstelSelection = (id, isEditing, shouldValidate = true) => {
        // If in edit mode and not meant for validation, do not change selection
        if (isEditing && !shouldValidate) return;
    
        setSelectedVoorstellen(prev => 
            prev.includes(id) 
                ? prev.filter(item => item !== id) 
                : [...prev, id]
        );
    };

    return (
        <div className='Screen-container'>
          
            <div className="title-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1 className="title">Controle Voorstel</h1>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <RangePicker 
                        value={dateRange}
                        format="DD/MM/YYYY" 
                        onChange={handleDateRangeChange}
                        />
                        <Button onClick={handleValidatie} type="primary" style={{ marginLeft: 10 }}>Valideer Geselecteerd</Button>
                    </div>
                </div>          
                <div style={{ overflowY: "auto", maxHeight }}>
                {voorstellen.length > 0 ? (
                                    voorstellen.map(voorstel => (
                                        <VoorstelCard 
                                            key={voorstel._id} 
                                            voorstel={voorstel}
                                            isSelected={selectedVoorstellen.includes(voorstel._id)}
                                            onToggleSelect={(isEditing) => toggleVoorstelSelection(voorstel._id, isEditing)}
                                            onRefresh={fetchVoorstellen}
                                        />
                                    ))
                                ) : (
                                    <Empty 
                                        description="Geen voorstellen gevonden" 
                                    
                                    />
                                )}
                </div>          
        </div>
    );
};

// Modified VoorstelCard component with generalized Add Product functionality
const VoorstelCard = ({ voorstel, isSelected, onToggleSelect, onRefresh }) => {
    const { get, put, del } = AxiosCaller();
    const [isEditing, setIsEditing] = useState(false);
    const [editingGerechten, setEditingGerechten] = useState({
        voorgerecht: { 
            ...voorstel.voorgerecht,
            aantal: voorstel.voorgerecht.aantal,
            producten: voorstel.voorgerecht.producten.map(p => ({...p}))
        },
        hoofdgerecht: { 
            ...voorstel.hoofdgerecht,
            aantal: voorstel.hoofdgerecht.aantal,
            producten: voorstel.hoofdgerecht.producten.map(p => ({...p}))
        },
        nagerecht: { 
            ...voorstel.nagerecht,
            aantal: voorstel.nagerecht.aantal,
            producten: voorstel.nagerecht.producten.map(p => ({...p}))
        }
    });
    const [originalGerechten, setOriginalGerechten] = useState({});
    const [allProducts, setAllProducts] = useState([]);
    const [showAddProduct, setShowAddProduct] = useState(false);
    const [newProduct, setNewProduct] = useState({
        product: '',
        aantal: 1
    });

    useEffect(() => {
        // Fetch all products when editing mode is enabled
        if (isEditing) {
            fetchAllProducts();
        }
    }, [isEditing]);

    const fetchAllProducts = async () => {
        try {
            const response = await get('/Product');
            setAllProducts(response.data);
        } catch (error) {
            openNotificationError("Fout bij ophalen van producten", error)
            console.error(error);
        }
    };

    const handleEditToggle = () => {
        if (!isEditing) {
            // Save the original state before editing
            setOriginalGerechten({
                voorgerecht: { 
                    ...voorstel.voorgerecht,
                    aantal: voorstel.voorgerecht.aantal,
                    producten: voorstel.voorgerecht.producten.map(p => ({...p}))
                },
                hoofdgerecht: { 
                    ...voorstel.hoofdgerecht,
                    aantal: voorstel.hoofdgerecht.aantal,
                    producten: voorstel.hoofdgerecht.producten.map(p => ({...p}))
                },
                nagerecht: { 
                    ...voorstel.nagerecht,
                    aantal: voorstel.nagerecht.aantal,
                    producten: voorstel.nagerecht.producten.map(p => ({...p}))
                }
            });
        }
        setIsEditing(!isEditing);
    };

    const handleUpdateVoorstel = async () => {
        try {
            await put(`/voorstel/${voorstel._id}`, {
                voorgerecht: editingGerechten.voorgerecht,
                hoofdgerecht: editingGerechten.hoofdgerecht,
                nagerecht: editingGerechten.nagerecht
            });
            openNotificationSuccess("Voorstel succesvol aangepast")
            setIsEditing(false);
            onRefresh();
        } catch (error) {
           openNotificationError("Fout bij aanpassen van voorstel" ,error)
            console.error(error);
        }
    };

    const handleRemoveVoorstel = async (id) => {
          
            try {
                await del(`/Voorstel/${id}`);
              openNotificationSuccess("Voorstel succesvol verwijderd")
                onRefresh();
            } catch (error) {
                openNotificationError("Fout bij verwijderen van voorstel", error)
                console.error(error);
            }
        
    };

    const updateProductAantal = (gerechtType, newAantal) => {
        setEditingGerechten(prev => {
            const updatedGerechten = {...prev};
            const currentGerecht = updatedGerechten[gerechtType];
            
            // Convert to number and ensure it's not NaN
            const oldAantal = Number(currentGerecht.aantal);
            const newGerechtAantal = Number(newAantal);
            
            // Validate input
            if (isNaN(newGerechtAantal) || newGerechtAantal <= 0) {
                openNotificationError('Aantal moet een geldig postief getal zijn')
                return prev;
            }
    
            // Update all product quantities proportionally
            const updatedProducten = currentGerecht.producten.map(productItem => {
                // Convert existing aantal to number
                const oldProductAantal = Number(productItem.aantal);
                
                // Calculate new product quantity proportionally
                const newProductAantal = (oldProductAantal / oldAantal) * newGerechtAantal;
                
                return {
                    ...productItem,
                    aantal: Number(newProductAantal.toFixed(2))
                };
            });
    
            // Update the gerecht with new aantal and updated producten
            currentGerecht.aantal = newGerechtAantal;
            currentGerecht.producten = updatedProducten;
            
            return updatedGerechten;
        });
    };

    const adjustProductQuantity = (gerechtType, productIndex, delta) => {
        setEditingGerechten(prev => {
            const updatedGerechten = {...prev};
            const producten = updatedGerechten[gerechtType].producten;
            
            producten[productIndex].aantal = Math.max(0, 
                producten[productIndex].aantal + (delta * producten[productIndex].product.minimumHoeveelheid)
            );
            
            return updatedGerechten;
        });
    };

    const handleAddProductClick = () => {
        setShowAddProduct(true);
        setNewProduct({
            product: '',
            aantal: 1
        });
    };

    const handleAddProduct = () => {
        if (!newProduct.product) {
            openNotificationError('Selecteer een product')
            return;
        }

        // Always add the product to voorgerecht in the background
        setEditingGerechten(prev => {
            const updatedGerechten = {...prev};
            
            // Add the new product to voorgerecht
            updatedGerechten.voorgerecht.producten.push({
                product: newProduct.product,
                aantal: Number(newProduct.aantal)
            });
            
            return updatedGerechten;
        });

        // Reset the add product state
        setShowAddProduct(false);
        setNewProduct({
            product: '',
            aantal: 1
        });
        try {
            put(`/voorstel/${voorstel._id}`, {
                voorgerecht: editingGerechten.voorgerecht,
                hoofdgerecht: editingGerechten.hoofdgerecht,
                nagerecht: editingGerechten.nagerecht
            });
            onRefresh();
        } catch (error) {
           openNotificationError("Fout bij aanpassen van voorstel" ,error)
            console.error(error);
        }
        openNotificationSuccess("Product succesvol toegevoegd")
    };

    const renderProductList = (producten, gerechtType) => {
        return (
            <>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                        {producten.map((product, index) => (
                            <tr 
                                key={`${product.product.naam}-${index}`} 
                                style={{ 
                                    borderBottom: '1px solid #f0f0f0',
                                    backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white'
                                }}
                            >
                                <td style={{ padding: '8px', width: '50%' }}>{product.product.naam}</td>
                                <td style={{ padding: '8px', textAlign: 'right', width: '50%' }}>
                                    <Space>
                                        <Button 
                                            icon={<MinusOutlined />} 
                                            size="small"
                                            type="text"
                                            onClick={() => adjustProductQuantity(gerechtType, index, -1)}
                                        />
                                        <Text>
                                            {Number(product.aantal).toFixed(1)} {product.product.eenheid.naam}
                                        </Text>
                                        <Button 
                                            icon={<PlusOutlined />} 
                                            size="small"
                                            type="text"
                                            onClick={() => adjustProductQuantity(gerechtType, index, 1)}
                                        />
                                    </Space>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    };

    const renderAddProductUI = () => {
        if (!isEditing) return null;

        return (
            <div style={{ marginTop: 24, width: '100%' }}>
                {!showAddProduct ? (
                    <Button 
                        type="dashed" 
                        icon={<PlusCircleOutlined />} 
                        onClick={handleAddProductClick}
                        style={{ width: '100%', height: '40px' }}
                        size="large"
                    >
                        Product Toevoegen
                    </Button>
                ) : (
                    <Card 
                        title="Nieuw Product Toevoegen" 
                        style={{ 
                            marginTop: 8,
                            boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                            width: '100%'
                        }}
                    >
                        <div style={{ width: '100%' }}>
                            <div style={{ marginBottom: 16, width: '100%' }}>
                                <div style={{ marginBottom: 8, fontWeight: 500 }}>Product</div>
                                <Select
                                    placeholder="Selecteer een product"
                                    style={{ width: '100%' }}
                                    value={newProduct.product ? newProduct.product.naam || newProduct.product : ''}
                                    onChange={(value) => {
                                        // Find the selected product object from allProducts
                                        const selectedProduct = allProducts.find(p => p.naam === value);
                                        setNewProduct(prev => ({ 
                                            ...prev, 
                                            product: selectedProduct 
                                        }));
                                    }}
                                    size="large"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                        return option.children.toString().toLowerCase().includes(input.toLowerCase());
                                    }}
                                >
                                    {allProducts.map((product) => (
                                        <Option key={product._id} value={product.naam}>
                                            {product.naam} ({product.eenheid.naam})
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <div style={{ marginBottom: 16, width: '100%' }}>
                                <div style={{ marginBottom: 8, fontWeight: 500 }}>Aantal</div>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={1}
                                    value={newProduct.aantal}
                                    onChange={(value) => setNewProduct(prev => ({ ...prev, aantal: value }))}
                                    size="large"
                                    step={1}
                                />
                            </div>

                            <div style={{ textAlign: 'right' }}>
                                <Button 
                                    type="primary" 
                                    onClick={handleAddProduct}
                                    style={{ width: '100%' }}
                                >
                                    Voeg toe
                                </Button>
                            </div>
                        </div>
                    </Card>
                )}
            </div>
        );
    };


    return (
        <Card 
            style={{ 
                marginBottom: 16, 
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                border: isSelected ? '2px solid #52c41a' : '1px solid #d9d9d9',
                backgroundColor: '#ffffff'
            }}
            actions={[
                // Edit Action - Centered vertically
                <div className="card-action" key="edit">
                    <EditOutlined 
                        onClick={handleEditToggle} 
                        style={{ fontSize: '16px' }}
                    />
                </div>,
            
                // Delete Action - Centered vertically
                <div className="card-action" key="delete">
                            <Popconfirm title="Weet je het zeker?" onConfirm={() => handleRemoveVoorstel(voorstel._id)}>
                              <DeleteOutlined className='delete-button'/>
                            </Popconfirm>
                </div>,
            
                // Goedkeuren/Goedgekeurd Action - Centered vertically
                <div className="card-action" key="status">
                    {isSelected 
                        ? <div className="card-action-approved">
                            <p onClick={() => onToggleSelect(isEditing)}>
                                Goedgekeurd 
                                <CheckCircle style={{ marginLeft: 8, fontSize: '16px' }} />
                            </p>
                        </div>
                        : <div className="card-action-pending">
                            <p onClick={() => onToggleSelect(isEditing)}>
                                Goedkeuren 
                                <Circle style={{ marginLeft: 8, fontSize: '16px' }} />
                            </p>
                        </div>}
                </div>
            ]}
        >       
            <Row 
                gutter={16} 
                align="middle" 
                className="card-header"
                style={{ display: 'flex'}}
                
            >
                <Col>
                    <p className="controleVoorstel-header-container">
                        <span className="controleVoorstel-header-label">Datum:</span>
                        <span className="controleVoorstel-header">{new Date(voorstel.kookDatum).toLocaleDateString('nl-NL')}</span>
                    </p>
                </Col>
                <Col>
                    <p className="controleVoorstel-header-container">
                        <span className="controleVoorstel-header-label">Klas: </span>
                        <span className="controleVoorstel-header">{voorstel.klas.naam}</span>
                    </p>
                </Col>
                <Col>
                    <p className="controleVoorstel-header-container">
                        <span className="controleVoorstel-header-label">Aantal: </span>
                        <span className="controleVoorstel-header">{voorstel.aantalStudenten}</span>
                    </p>
                </Col>
                <Col>
                    <p className="controleVoorstel-header-container">
                        <span className="controleVoorstel-header-label">Leerkracht: </span>
                        <span className="controleVoorstel-header">{voorstel.leerkracht.naam}</span>
                    </p>
                </Col>
            </Row>

            {isEditing ? (
                <Row gutter={[16, 16]}>
                    {['voorgerecht', 'hoofdgerecht', 'nagerecht']
                        .filter(gerechtType => 
                            editingGerechten[gerechtType].producten && 
                            editingGerechten[gerechtType].producten.length > 0
                        )
                        .map(gerechtType => (
                            <Col key={gerechtType} md={24}>
                                <Card 
                                    title={
                                        <div 
                                            style={{
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'center', 
                                                width: '100%'
                                            }}
                                        >
                                            <span>{gerechtType.charAt(0).toUpperCase() + gerechtType.slice(1)}</span>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ marginRight: 8 }}>Aantal Leerlingen:</span>
                                                <InputNumber 
                                                    size="small"
                                                    value={editingGerechten[gerechtType].aantal}
                                                    onChange={(value) => updateProductAantal(gerechtType, value)}
                                                    min={1}
                                                    style={{ width: 70 }}
                                                />
                                            </div>
                                        </div>
                                    } 
                                    size="small"
                                    style={{ marginBottom: 16 }}
                                >
                                    {renderProductList(editingGerechten[gerechtType].producten, gerechtType)}
                                </Card>
                            </Col>
                        ))}
                    
                    {/* Add the general "Add Product" button here after all gerecht cards */}
                    {renderAddProductUI()}
                </Row>
            ) : (
                <Row gutter={[16, 16]}>
                    {[
                        { type: 'voorgerecht', name: voorstel.voorgerecht.naam },
                        { type: 'hoofdgerecht', name: voorstel.hoofdgerecht.naam },
                        { type: 'nagerecht', name: voorstel.nagerecht.naam }
                    ]
                    .filter(gerecht => 
                        voorstel[gerecht.type].producten && 
                        voorstel[gerecht.type].producten.length > 0
                    )
                    .map(gerecht => (
                        <Col key={gerecht.type} xs={24} md={8}>
                            <Card 
                                size="small" 
                                title={
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span>{gerecht.type.charAt(0).toUpperCase() + gerecht.type.slice(1)}</span>
                                        <Text>{voorstel[gerecht.type].aantal}</Text>
                                    </div>
                                }
                            >
                                <Text>{gerecht.name}</Text>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}

            {voorstel.opmerking && (
                <div 
                    style={{ 
                        marginTop: 16, 
                        backgroundColor: '#fffbe6', 
                        padding: 12, 
                        borderRadius: 4,
                        borderLeft: '4px solid #faad14',
                    }}
                >
                    <Text style={{ color: 'black' }} type="warning">
                        Opmerking: {voorstel.opmerking}
                    </Text>
                </div>
            )}

            {isEditing && (
                <div style={{ marginTop: 16, textAlign: 'center' }}>
                    <Space>
                        <Button type="primary" onClick={handleUpdateVoorstel}>Opslaan</Button>
                        <Button onClick={() => {
                            // Restore the original data
                            setEditingGerechten(originalGerechten);
                            setIsEditing(false);
                            setShowAddProduct(false);
                        }}>Annuleren</Button>
                    </Space>
                </div>
            )}
        </Card>
    );
};

export default ControleVoorstelScreen;